import { getArticlesFromCart } from "@/graphql/schemas/shared/utils/getArticles"
import { getCustomer } from "@/graphql/schemas/shared/utils/getCustomer"
import { AppSettings } from "@/settings"

import { checkPermissions, validateAccessRightsToCustomer } from "../../shared/permissions/permissions"
import { DomainObjects, Operations } from "../../shared/permissions/permissionsConfig"
import { getActiveCustomerCart } from "../utils/getCart"

/**
 * Differs from query customer carts
 *
 * Retrieves only an active cart as an object provided customer id
 * query customer carts used to retrieve previous orders if there are any
 */
export const queryPaginatedCustomerCart = {
  async paginatedCustomerCart(parent, args, context, info) {
    const { customerId, customerNumber, lang, cdn, loggedInBranch, regionSanityId, limit, offset } = args
    const { user } = context

    await checkPermissions({
      user,
      domainObject: DomainObjects.CARTS,
      operation: Operations.READ,
    })

    const customer = await getCustomer({ number: customerNumber, id: customerId })

    if (!customer) return null

    await validateAccessRightsToCustomer({
      user: user,
      customerNumber: customer.customerNumber,
    })

    const cart = await getActiveCustomerCart(customer.id, user.employeeNumber)

    if (!cart[0] || cart[0]?.customLineItems?.length === 0) {
      return cart[0]
    }

    const itemsToShow = offset + limit
    const lineItemsToShow = cart[0]?.customLineItems?.slice(offset, itemsToShow)

    const customerCart = {
      ...cart[0],
      customLineItems: lineItemsToShow,
    }

    const config = AppSettings.sanityConfigByLang(lang)
    const client = context.sanityClient
    client.config({ ...config, useCdn: cdn })

    const updatedCart = await getArticlesFromCart(
      customerCart,
      client,
      loggedInBranch,
      false,
      user,
      customer.customerNumber,
      regionSanityId,
    )

    return updatedCart ?? null
  },
}
